import "../../styles/menu.scss";
import React, { useEffect } from "react";
import { ClientProviderEnum } from "../../constants";
import SearchMenuSection from "../Menu/Search/SearchMenuSection";
import TopMenuSection from "../Menu/TopMenuSection/TopMenuSection";
import HomeSection from "../../segmentedComponents/HomeSection";
import CategoriesMobile from "../Menu/Categories/CategoriesMobile";
import RegulationLogosSection from "../../segmentedComponents/RegulationLogosSection";
import SecondaryMenu from "../../segmentedComponents/SecondaryMenu";
import { useSelector } from "react-redux";
import { SearchSelectors } from "../../redux/selectors";
import { BrandUtils } from "../../utils/brandUtils";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators";
import { PageContextUtils, ThemeUtils } from "../../utils";
import { MobileCrossActivity } from "../../segmentedComponents/CrossActivity/loader";
import {
  HamburgerMenuMobileWrapper,
  HamburgerMenuMobileHomeSectionWrapper
} from "./components/HamburgerMenuMobileWrapper";

const HamburgerMenuMobile = () => {
  const dispatch = useDispatch();
  const searchActive = useSelector(SearchSelectors.searchActive);
  const { name } = PageContextUtils.getClientProviderData();

  useEffect(() => {
    setTimeout(() => {
      dispatch(MenuActionCreators.setDrawersRendering(false));
      dispatch(MenuActionCreators.setDrawersLoaded(true));
    }, 250);
  }, [dispatch]);

  return (
    <HamburgerMenuMobileWrapper data-testid={"uc-hamburger-menu"}>
      {!searchActive && <MobileCrossActivity />}
      {name === ClientProviderEnum.Kambi && <SearchMenuSection />}
      <div
        className={`searchAnimation${searchActive ? " animationStart" : ""}`}
      >
        {ThemeUtils.isMrGreenTheme() ? (
          <>
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
            <TopMenuSection />
          </>
        ) : (
          <>
            <TopMenuSection />
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
          </>
        )}
        <HamburgerMenuMobileHomeSectionWrapper>
          <HomeSection />
        </HamburgerMenuMobileHomeSectionWrapper>
        {!BrandUtils.isPokerClient() && <CategoriesMobile />}
        <RegulationLogosSection showControlCenter={true} />
        <SecondaryMenu />
      </div>
    </HamburgerMenuMobileWrapper>
  );
};

export default React.memo(HamburgerMenuMobile);
